import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    $(this.element).carousel({
      ride: 'carousel',
      pause: false,
    });
  }

  beforeCache() {
    $(this.element).carousel(0);
  }
}
